import { userService } from '.';

export function handleResponse(response: any) {
  return response.text().then((text: string) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      const error = data || response.statusText;
      return Promise.reject(error);
    }

    const headers: any = [];

    for (const pair of response.headers.entries()) {
      headers.push({ key: pair[0], value: pair[1] });
    }
    return {
      data,
      headers
    };
  });
}
